export default function TeacherPage() {
  return (
    <div>
      <h1 style={{ fontSize: '1.8rem', fontWeight: 700, color: '#1a1c2c', marginBottom: '1rem' }}>
        📖 Mis Grupos
      </h1>
      <p style={{ color: '#888' }}>Portal para docentes pendiente de implementación.</p>
    </div>
  );
}
